import React, { Component } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import { connect } from "react-redux";
import TextField from "../fields/TextField";

class PaymentsFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Payments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <TextField name="payment_payer" label="Payer" col={6} action="edit" />
            <TextField name="payment_amount" label="Payment Amount" col={6} action="edit" />
            <TextField name="payment_frequency" label="Payment Frequency" col={6} action="edit" />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="info"
            onClick={() => this.props.closeModal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.paymentsModal.show,
    hasDelete: state.current_user.permissions.includes("Delete"),
    hasEdit: state.current_user.permissions.includes("Edit")
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "payments" }})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsFormModal);
